export default "__VITE_ASSET__CYrDzI80__"